import isObject from "./isObject.js";
/**
    Determines if the object passed is the document or window.
    @param obj @private
*/ function validObject(obj) {
    if (typeof window === "undefined") return true;
    else return obj !== window && obj !== document;
}
/**
    A deeply recursive version of `Object.assign`.

@example <caption>this</caption>
assign({id: "foo", deep: {group: "A"}}, {id: "bar", deep: {value: 20}}));
    @example <caption>returns this</caption>
{id: "bar", deep: {group: "A", value: 20}}
    @param objects The source objects to merge into the target.
*/ function assign() {
    var _loop = function(i) {
        var source = objects[i];
        if (!isObject(source)) return "continue";
        Object.keys(source).forEach(function(prop) {
            var value = source[prop];
            if (isObject(value) && validObject(value)) {
                if (Object.prototype.hasOwnProperty.call(target, prop) && isObject(target[prop])) target[prop] = assign({}, target[prop], value);
                else target[prop] = assign({}, value);
            } else if (Array.isArray(value)) target[prop] = value.slice();
            else target[prop] = value;
        });
    };
    for(var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++){
        objects[_key] = arguments[_key];
    }
    var target = objects[0];
    for(var i = 1; i < objects.length; i++)_loop(i);
    return target;
}
export default assign;

//# sourceMappingURL=assign.js.map